import React, { Suspense, lazy } from 'react';
import Hero from "../hero/Hero";
import Article from "../article/Article"
import { FaRegFilePdf } from "react-icons/fa";
import { Helmet } from "react-helmet";
import Placeholder from '../generic/Placeholder'


const Features = lazy(() => import("../features/Features"))
const Pricing = lazy(() => import("../pricing/Pricing"))
const ContactForm = lazy(() => import("../contact-form/ContactForm"))
const QuestionsAndAnswers = lazy(() => import("../questions-and-answers/QuestionsAndAnswers"))
const Resources = lazy(() => import("../resources/Resources"))
const Presentations = lazy(() => import("../presentations/Presentations"))

const resourcesList = [
    {
        icon: <FaRegFilePdf/>,
        title: "Mailwall Email Filtering Brochure",
        source: "resources/downloads/Mailwall-Email-Filtering-Brochure.pdf",
    },
    {
        icon: <FaRegFilePdf/>,
        title: "Mailwall Email Filtering User Guide",
        source: "resources/downloads/Mailwall-Email-Filtering-Remote-User-Guide.pdf",
    }
]


const PageMailwallCloudAntiSpamFiltering = () => {
    return (
        <>
            <Helmet>
                <title>Mailwall - Email Filtering</title>
                <meta name="description" content="Mailwall - advanced email filtering services for business. See how Omniquad's email protection can meet all your online security needs."/>
            </Helmet>

            <main className={"Page"}>
                <Hero showButtons mailwallTrial>
                    <h1>Mailwall – Anti-Spam Filtering For Business</h1>
                    <p>Get All-in-One advanced email threat protection for your organization today with Email Security Simplified.</p>
					<p>Block spam, phishing, viruses, malware, ransomware and malicious email threats before they harm your Business. Provides advanced yet easy to use email spam filtering with 24x7x365 monitoring, 99.99% spam catch rate & 0.001% false positive ratio.</p>
                    <p>Deploy in Less than 5 Minutes without changing the Email Flow.</p>
                    <ul>
                        <li><strong>Double Anti-Virus Protection</strong></li>
                        <li><strong>Protection from Zero Day Attacks</strong></li>
                        <li><strong>Dedicated RBLs</strong></li>
                        <li><strong>Industry Leading Support Team</strong></li>
						<li><strong>Office 365 Additional Protection Layer</strong></li>
						<li><strong>GDPR Compliance</strong></li>
                        <li><strong>TLS, DMARC, SPF & DKIM</strong></li>
                        <li><strong>Stops 100% Viruses</strong></li>
                        <li><strong>Stops 99.99% Spam</strong></li>
                    </ul>
                </Hero>
                <Article>
                    <Suspense fallback={<Placeholder />}>
                        <Features dataFile="featuresData-2.js" />
                    </Suspense>
                </Article>
            </main>
            <Suspense fallback={<Placeholder />}>
                <Pricing/>
                <ContactForm variant={"mailwall"} />
                <QuestionsAndAnswers/>
                <Resources resourcesList={resourcesList}/>
                <Presentations/>
            </Suspense>
        </>
    )
}

export default PageMailwallCloudAntiSpamFiltering;